const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // 通过快遞單號、清关单号、出货单号等查詢快递包裹、出货包裹
  searchParcelOrdersubtno ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-parcel-ordersubtno', {params})
  },
  searchHawb ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-hawb', {params})
  },
  searchSea ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-sea', {params})
  },
  searchSelfDelivery ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-self-delivery', {params})
  },
  batchPushnsPreApntd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/batch-pushns-pre-apntd', params)
  },
  coOrderjytnAssignTno ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/co-orderjytn-assign-tno', params)
  },
  batchPushnsTvUnverified ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/batch-pushns-tv-unverified', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

// // 通过快递单号搜索清關信息
// /jyb/v1frontend/ordersubtno/search-hawb?trackingNo=xxx

// // 通过快遞單號、清关单号、出货单号等查詢快递包裹、出货包裹
// /jyb/v1frontend/ordersubtno/search-parcel-ordersubtno

// // 海運取件碼取件
// /jyb/v1frontend/ordersubtno/search-ordersubtno-sea



// WEBPACK FOOTER //
// ./src/store/modules/jyb/ordersubtno.js